<script setup lang="ts">
import Charger from '@/classes/charger_classes/charger'
import FavouriteLocation from '@/classes/favouriteLocation'
import getAssetSrc from '@/utils/getAssetSrc'
import { computed } from 'vue'

const defaultChargerIcon = getAssetSrc('icons/DC.svg')
const defaultLocationIcon = getAssetSrc('icons/Pin.svg')

const { location } = defineProps<{
  location: Charger | FavouriteLocation
}>()

const locationType = computed<'charger' | 'favLocation' | 'unknown'>(() => {
  if (location instanceof Charger) return 'charger'
  if (location instanceof FavouriteLocation) return 'favLocation'
  return 'unknown'
})

const title = computed(() => {
  if (locationType.value === 'charger') return location.name
  if (locationType.value === 'favLocation') return location.name
  return 'Unknown location'
})
const subtitle = computed(() => {
  if (locationType.value === 'charger') return location.address
  if (locationType.value === 'favLocation') return location.address
  return 'Unknown location'
})
const iconSrc = computed(() => {
  if (locationType.value === 'charger') return defaultChargerIcon
  if (locationType.value === 'favLocation') return defaultLocationIcon
  return undefined
})

const emit = defineEmits<{ (e: 'click'): void }>()

</script>
<template>
  <v-card
    flat
    class="pa-5 d-flex align-center flex-nowrap justify-space-between"
    @click.stop="emit('click')"
  >
    <div class="flex-grow-0 flex-shrink-0">
      <img v-if="iconSrc" :src="iconSrc" width="42px" height="42px" />
      <v-icon v-else color="pwt_red"> mdi-alert-octagon-outline </v-icon>
    </div>
    <div class="flex-grow-1 flex-shrink-1 overflow-hidden">
      <v-card-title class="text-truncate py-0"> {{ title }} </v-card-title>
      <v-card-subtitle class="text-truncate"> {{ subtitle }} </v-card-subtitle>
    </div>
  </v-card>
</template>
